import React, { useContext } from "react";
import { RicosContext } from "./../ricos-context/index.js";
import { IFRAME_COMPONENT } from "./data-hooks.js";
import styles from "./statics/styles/Iframe-scss.js";
const Iframe = ({ iframeRef, isViewer, ...otherProps }) => {
  const { tabIndex } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    "iframe",
    {
      ref: iframeRef,
      className: styles.iframe,
      title: "remote content",
      "data-hook": IFRAME_COMPONENT,
      style: { backgroundColor: "transparent" },
      allow: isViewer ? "fullscreen; autoplay; encrypted-media" : "fullscreen; encrypted-media",
      allowFullScreen: true,
      ...otherProps,
      tabIndex
    }
  );
};
export {
  Iframe
};
//# sourceMappingURL=iframe.js.map
